<template>
  <div>
    <p class="top-title">LIFE DESIGN COURSE</p>
    <h1>
      <span>{{ userNick }}</span>
      님의 생애연표
    </h1>
    <p class="body-2">{{ userEmail }}</p>
  </div>
</template>

<script>
export default {
  name: 'SummaryName',
  props: {
    userNick: {
      type: String,
      default: '다이조부',
    },
    userEmail: {
      type: String,
      default: 'abc@gmail.com',
    },
  },
}
</script>

<style lang="scss" scoped>
p,
span,
h1 {
  color: #1c5eaa;
}
p.top-title {
  margin-top: 20px;
  font-family: SamsungSans !important;
  font-size: 12px;
  font-weight: 900;
  margin-bottom: 8px;
  width: 114px;
  padding: 4px 0 0 0;
  border-top: 1px solid #1c5eaa;
  border-bottom: 1px solid #1c5eaa;
}
h1 {
  font-weight: 400;
  font-size: 20px;
  span {
    font-weight: 600;
    font-size: 28px;
  }
}
</style>
